import React from "react";
import Modal from "react-modal";
import SendEmailComposeWidget from "./SendEmailComposeWidget";

/**
 * Modal shell around {@link SendEmailComposeWidget} — same flow as /cms/email for one recipient.
 */
export default function SendEmailComposeModal({
  isOpen,
  onClose,
  toEmail,
  recipientName,
  onSent,
}) {
  return (
    <Modal
      closeTimeoutMS={500}
      isOpen={isOpen}
      onRequestClose={onClose}
      className="Modal send-email-compose-modal-root no-scrollbar"
      overlayClassName="Overlay"
    >
      <div className="modal-content send-email-compose-modal-content">
        <div className="modal-header">
        <h4 className="modal-title">
            Send email
            {recipientName ? ` — ${recipientName}` : ""}
          </h4>
          <button type="button" className="close" onClick={onClose}>
            <span aria-hidden="true">&times;</span>
          </button>
          
        </div>
        <div className="modal-body send-email-compose-modal-body">
          <SendEmailComposeWidget
            toEmail={toEmail}
            onCancel={onClose}
            onSent={(data) => {
              if (onSent) onSent(data);
              onClose();
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
